export default {
  header: {
    title: 'Super! Sie erhalten Folgendes kostenlos zu Ihrer Bestellung:',
    subtitle: 'Wir wenden den Rabatt während des Checkout-Prozesses an.',
  },
  footer: {
    buttons: {
      no_thanks: 'Nein, danke',
      add_to_basket: 'Zum Warenkorb hinzufügen',
    },
  },
};
